<script>
  import { Link } from "svelte-routing";
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Mea+Culpa&display=swap');
html,body ,
h1{
	font: 400 2.615rem/2.675rem 'Mea Culpa', cursive;
}
h3{
	font: 400 2.415rem/2.475rem 'Mea Culpa', cursive;
}
h5{
	font: 400 2.015rem/2.075rem 'Mea Culpa', cursive;
}
	p {
	font: 100 1.615rem/1.675rem 'Mea Culpa', cursive;
}	j {
	font: 100 1.815rem/1.875rem 'Mea Culpa', cursive;
}
</style> 

        <div 
		style="background-image: url(https://mesinkasir.github.io/larapos/img/wedding/wedding.jpg);
		background-repeat: no-repeat;
		background-attachment: fixed;
  background-position: center; 
   background-size: cover;
		"
		>
           <div class="container">
		   <div class="row py-5">
		   <div class="col-12 p-3 p-md-5 text-center"></div>
		   <div class="col-12 p-3 p-md-5">
		   <div class="bg-white rounded shadow p-3 p-md-5 text-center" style="opacity:0.8;">
		   <h5>- Be Married -</h5>
		   <h1 class="uk-heading-xlarge border border-dark p-3 "><strong>William Tanujaya <br>& <br>Ina Indrasari</strong></h1>
		   <j>Kamis 10 febuari 2022</j>
		   <p class="p-5">Anda diundang<br>Click tombol enter untuk informasi detail mengenai acara ini.</p>
		   <Link to="/start" class="btn btn-dark">E N T E R</Link>
		   </div>
		   </div>
		   </div>
		   </div>
		    <div class="col-12 p-1 text-center">
			<small>wedding online <a href="https://creativebydre.vercel.app">creative by dre</a></small>
			</div>
    </div>
